// define global namespace
window.App = {
  Library: {},
  Views: {}
}
